//Life Style Card Enums
export const redFlagSymptomsEnum = {
  question: "Do you have any of the following symptoms?",
  subquestion: "Select all that apply.",
  options: [
    {
      value: "wheezing",
      header: "Shortness of breath or wheezing",
      subHeader: null,
    },
    {
      value: "headache",
      header: "Persistent headache",
      subHeader: null,
    },
    {
      value: "eyePain",
      header: "Persistent facial pain or eye pain",
      subHeader: null,
    },
    {
      value: "unilatiralNoseSymptoms",
      header: "Symptoms in one nostril (primarily unilateral)",
      subHeader: null,
    },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const nasalSymptomsEnum = {
  question: "Select if you have any of the following allergy  symptoms:",
  subquestion: null,
  options: [
    {
      value: "runnyNose",
      header: "Clear, watery and runny nose (Rhinorrhea)",
      subHeader: null,
    },
    {
      value: "sneezing",
      header: "Sneezing",
      subHeader: null,
    },
    {
      value: "itchyNoseEyesThroat",
      header: "Itchy nose, eyes, and throat",
      subHeader: null,
    },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const nasalCongestionEnum = {
  question: "Select level of congestion:",
  subquestion: null,
  options: [
    { value: "minorCongestion", header: "Minor congestion", subHeader: null },
    { value: "moderateCongestion", header: "Major congestion", subHeader: null },
    { value: "noCongestion", header: "No congestion", subHeader: null },
  ],
};

export const visibleSymptomsEnum = {
  question: "Select if you have any of the following allergy  symptoms:",
  subquestion: null,
  options: [
    { value: "allergicSalute", header: "Allergic Salute", subHeader: null },
    { value: "allergicShiner", header: "Allergic Shiner", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const otherSymptomsEnum = {
  question: "Select if you have any of the following allergy  symptoms:",
  subquestion: null,
  options: [
    { value: "cough", header: "Cough related to post nasal drip", subHeader: null },
    { value: "irritability", header: "Irritability, feeling tired or fatigue", subHeader: null },
    { value: "itchyEars", header: "Itchy ears", subHeader: null },
    { value: "itchyEyes", header: "Itchy eyes", subHeader: null },
    { value: "wateryEyes", header: "Clear watery eyes", subHeader: null },
    { value: "postNasalDrip", header: "Post nasal drip (down back of throat)", subHeader: null },
    { value: "skinRash", header: "Skin rashes or hives", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
};


export const infectiveRhinitisDurationEnum = {
  question: "How long have you had the symptoms?",
  subquestion: null,
  options: [
    { value: "none", header: "Symptoms for LESS than 7 DAYS", subHeader: null },
    { value: "sevenToTenDays", header: "Symptoms for 7 to 10 DAYS", subHeader: null },
    { value: "twelveWeeksOrMore", header: "Symptoms for 12 WEEKS or longer", subHeader: null },

  ],
};

export const infectiveRhinitisSymptomsEnum = {
  question: "Do you have any upper respiratory symptoms?",
  subquestion: "Select all that apply",
  options: [
    { value: "cough", header: "Cough (persistent)", subHeader: null },
    { value: "fever", header: "Fever", subHeader: null },
    { value: "postNasalDrip", header: "Post nasal drip with thick mucous", subHeader: null },
    { value: "purulentNasalDischarge", header: "Purulent Nasal Discharge", subHeader: "(thick green or yellow discharge)" },
    { value: "soreThroat", header: "Sore throat", subHeader: null },
    { value: "swollenGlands", header: "Swollen glands", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const chronicRhinosinusitisDurationEnum = {
  question: "May consider an inflammatory condition of the sinuses.",
  subquestion: "How long have you had the symptoms?",
  options: [
    { value: "twelveWeeksOrMore", header: "Symptoms for 12 weeks or longer", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const chronicRhinosinusitisSymptomsEnum = {
  question: "Two or more symptoms must be present for at least 12 weeks. Select all that apply",
  subquestion: null,
  options: [
    { value: "decreasedSenseOfSmell", header: "Decreased sense of smell", subHeader: null },
    { value: "facialPain", header: "Facial pain", subHeader: null },
    { value: "mucopurulentDrainage", header: "Mucopurulent drainage", subHeader: "(thick green or yellow discharge)" },
    { value: "nasalObstruction", header: "Nasal obstruction", subHeader: null },
    { value: "pressureOrFullness", header: "Pressure or fullness", subHeader: null },
    { value: "none", header: "None", subHeader: null },
  ],
};

export const allergensEnum = {
  options: [
    { value: "dustMites", header: "Dust Mites"},
    { value: "grass", header: "Grass"},
    { value: "indoorMold", header: "Indoor Mold"},
    { value: "petDander", header: "Pet dander"},
    { value: "pollen", header: "Pollen"},
    { value: "trees", header: "Trees"},
    { value: "weeds", header: "Weeds"},
    { value: "none", header: "None"},
  ]
};

